<picture>
  <img src="{{ source }}" class="img-loader" [alt]="alt" />
</picture>
